<template>
  <div id="course_list">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <div class="hotgkt">
      <div class="BreadcrumbNavigation">
        <strong>您当前所在位置：</strong><a href="/">首页</a>
        &gt;&gt; <span>课程列表</span>
      </div>
    </div>
    <!-- bottombox end -->
    <div class="screen">
      <div class="clearfix screen_2" :class="{ up: screenup }">
        <p>
          <strong>课程分类：</strong>
          <span>
            <a :class="{ side: num == 0 }" @click="CourseClick(0)">不限</a>
            <a :class="{ side: num == index + 1 }" v-for="(item, index) in CourseType_enum"
              @click="CourseClick(index + 1)">{{ item.Name }}</a>
          </span>
        </p>
        <p v-if="CourseC1">
          <strong>分数分类：</strong>
          <span>
            <a :class="{ side: num2 == 0 }" @click="scoreClick(0)">不限</a>
            <a v-for="(item, index) in Subject_List" v-if="item.Type == 1" :class="{ side: num2 == index + 1 }"
              @click="scoreClick(index + 1)">{{ item.Name }}</a>
          </span>
        </p>
        <p v-if="CourseC1">
          <strong>科目分类：</strong>
          <span>
            <a :class="{ side: num3 == 0 }" @click="SubClick(0)">不限</a>
            <a v-for="(item, index) in Subject_List" v-if="item.Type == 2" :class="{ side: num3 == index + 1 }"
              @click="SubClick(index + 1)">{{ item.Name }}</a>
          </span>
        </p>
        <p>
          <strong>班型选择：</strong>
          <span>
            <a :class="{ side: num4 == 0 }" @click="ClassClick(0)">不限</a>
            <!-- <a >大班直播课</a><a>小班互动直播课</a><a>1对1互动直播课</a><a>视频课</a> -->
            <a v-for="(item, index) in BjType_enum" :class="{ side: num4 == index + 1 }"
              @click="ClassClick(index + 1)">{{ item.Name }}</a>
          </span>
        </p>
        <!-- <p>
          <strong>适合学生：</strong>
          <span>
            <a :class="{ side: num5 == 0 }" @click="StudentClick(0)">不限</a>
            <a v-for="(item, index) in Student_enum" :class="{ side: num5 == index + 1 }"
              @click="StudentClick(index + 1)">{{ item.Name }}</a>
          </span>
        </p> -->
      </div>
      <div class="clearfix screen_3">
        <strong>排序方式</strong>
        <a :class="{ side: num6 == 0 }" @click="pxfsFu(0)">最新发布</a>
        <a :class="{ side: num6 == 2 }" @click="pxfsFu(2)">开课时间</a>
        <a :class="{ side: num6 == 1 }" @click="pxfsFu(1)">价格
          <!-- <em>
            <i class="el-icon-caret-top" :class="{sideUp:sideUp}"></i>
            <i class="el-icon-caret-bottom" :class="{sideUp:sideDwon}"></i>
          </em> -->
        </a>
        <span>共 {{ total }} 个课程</span>
      </div>
      <!-- <div class="clearfix screen_S">
        <input type="text" placeholder="输入关键词以搜索课程" v-model="searchValue" @keyup.enter="searchEnter"
          @focus="searchfocus(1)" @blur="searchblur(2)" />
        <button class="search_btn" type="primary" @click="searchClick">
          搜索
        </button>
      </div> -->
    </div>
    <!-- screen end -->
    <div class="main">
      <div class="main_list w1200">
        <ul class="clearfix">
          <li v-for="item,index in listBox" :key="index">
            <router-link :to="{path:'/course_details',query:{Id:item.Id,nav:8}}">
              <dl>
                <dt><img :src="item.CoverImg"><i
                    :class="[item.Type == 2?'courseBox':'']">{{item.Type == 2?'课程包':''}}</i></dt>
                <dd class="dd1">
                  <h2>{{item.Title}}</h2>
                  <p class="p1">
                    <span v-if="item.ClassTypeName">{{item.ClassTypeName}}</span>
                    <span v-if="item.CourseTypeName">{{item.CourseTypeName}}</span>
                  </p>
                  <div class="p3">
                    ￥{{item.Price}}
                  </div>
                </dd>
                <!-- <dd class="dd2">
                  <h2>{{item.Title}}</h2>
                  <p class="p2">
                    {{item.ServiceType}}
                  </p>
                  <p class="p1">
                    <span v-if="item.ClassTypeName">{{item.ClassTypeName}}</span>
                    <span v-if="item.CourseTypeName">{{item.CourseTypeName}}</span>
                  </p>
                  <p class="p4">
                    立即学习
                  </p>
                </dd> -->
              </dl>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- main_list end -->
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="currentPage" :page-size="12" :total="total" background
          layout="total,prev, pager, next, jumper,->">
        </el-pagination>
      </div>
      <!-- block end -->
    </div>
    <!-- main end -->
  </div>
</template>

<script>
  import detailsBox from "../publicClass/publicClass_list.vue";
  import Header from "../../components/header/Header.vue"; //公共头部

  import banner from "../../page2/banner/banner.vue"; //头部banner图
  export default {
    name: "course_list",
    components: {
      // 将组件隐射为标签,登录弹窗
      Header,

      banner
    },
    metaInfo() {
      return {
        title: "精品课程",
        meta: [{
            name: "keywords",
            content: "启德考培在线课程,雅思在线课程,托福在线课程,雅思课程,托福课程"
          },
          {
            name: "description",
            content: "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
          }
        ]
      };
    },
    data() {
      return {
        tokenkey: "",
        pageTypeId: 20, //教师banner图
        screenup: false,
        currentPage: 1,
        sideUp: false,
        sideDwon: false,
        CourseType_enum: "", //课程枚举
        num: 0,
        num2: 0,
        num3: 0,
        num4: 0,
        num5: 0,
        num6: 0,
        CourseC1: false,
        Subject_List: "", //科目枚举
        BjType_enum: "", //班级枚举
        classList: "", //班级列表
        Student_enum: "", //适用学生枚举
        listBox: [], //列表盒子
        total: 0, //总条数
        courseId: 0,
        scoreId: 0,
        subjectId: 0,
        classId: 0,
        studentId: 0,
        num6: 0,
        searchValue: "",
        CourseIds: this.$route.query.CourseIds || ""
      };
    },
    methods: {
      iconShrink() {
        this.screenup = true;
      },
      iconOpen() {
        this.screenup = false;
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        let that = this;
        // console.log(`当前页: ${val}`);
        this.currentPage = val;
        that.getDataListFu(
          that.currentPage,
          that.courseId,
          that.scoreId,
          that.subjectId,
          that.classId,
          that.studentId,
          that.num6,
          this.searchValue,
          this.CourseIds
        );
      },
      getDataListFu(
        currentPage,
        courseId,
        scoreId,
        subjectId,
        classId,
        studentId,
        num6,
        keyword,
        CourseIds
      ) {
        // console.log("keyword", keyword)
        let that = this;
        this.$api.get(
          "https://schoolapi.eiceducation.com.cn/api/Course?page=" +
          currentPage +
          "&limit=12&courseType=" +
          courseId +
          "&scoreType=" +
          scoreId +
          "&subjectType=" +
          subjectId +
          "&classType=" +
          classId +
          "&studentType=" +
          studentId +
          "&orderType=" +
          num6 +
          "&keyword=" +
          keyword +
          "&courseIds=" +
          CourseIds,
          "",
          res => {
            if (res.data.code == 200) {
              // console.log(res)
              that.listBox = res.data.results;
              that.total = res.data.count;
            }
          }
        );
      },
      //课程
      CourseClick(a) {
        let that = this;
        that.num = a;
        that.num3 = 0;
        that.num2 = 0;
        that.scoreId = 0;
        that.subjectId = 0;
        that.currentPage = 1;
        if (that.num == 0) {
          //课程不限
          that.CourseC1 = false;
          that.courseId = 0;
          that.getDataListFu(
            that.currentPage,
            that.courseId,
            that.scoreId,
            that.subjectId,
            that.classId,
            that.studentId,
            that.num6,
            this.searchValue,
            this.CourseIds
          );
        } else {
          that.CourseC1 = true;
          that.Subject_List = that.CourseType_enum[that.num - 1].List;
          that.courseId = that.CourseType_enum[that.num - 1].Id; //课程Id
          that.getDataListFu(
            that.currentPage,
            that.courseId,
            that.scoreId,
            that.subjectId,
            that.classId,
            that.studentId,
            that.num6,
            this.searchValue,
            this.CourseIds
          );
        }
      },
      // 分数
      scoreClick(b) {
        let that = this;
        that.num2 = b;
        that.currentPage = 1;
        if (that.num2 == 0) {
          //分数不限
          that.scoreId = 0;
          that.getDataListFu(
            that.currentPage,
            that.courseId,
            that.scoreId,
            that.subjectId,
            that.classId,
            that.studentId,
            that.num6,
            this.searchValue,
            this.CourseIds
          );
        } else {
          that.scoreId = that.Subject_List[b - 1].Id; //分数Id
          that.getDataListFu(
            that.currentPage,
            that.courseId,
            that.scoreId,
            that.subjectId,
            that.classId,
            that.studentId,
            that.num6,
            this.searchValue,
            this.CourseIds
          );
        }
      },
      // 科目
      SubClick(c) {
        let that = this;
        that.num3 = c;
        that.currentPage = 1;
        if (that.num3 == 0) {
          //科目不限
          that.subjectId = 0;
          that.getDataListFu(
            that.currentPage,
            that.courseId,
            that.scoreId,
            that.subjectId,
            that.classId,
            that.studentId,
            that.num6,
            this.searchValue,
            this.CourseIds
          );
        } else {
          that.subjectId = that.Subject_List[c - 1].Id;
          that.getDataListFu(
            that.currentPage,
            that.courseId,
            that.scoreId,
            that.subjectId,
            that.classId,
            that.studentId,
            that.num6,
            this.searchValue,
            this.CourseIds
          );
        }
      },
      //班型
      ClassClick(d) {
        let that = this;
        that.num4 = d;
        that.currentPage = 1;
        if (that.num4 == 0) {
          //班型不限
          that.classId = 0;
          that.getDataListFu(
            that.currentPage,
            that.courseId,
            that.scoreId,
            that.subjectId,
            that.classId,
            that.studentId,
            that.num6,
            this.searchValue,
            this.CourseIds
          );
        } else {
          that.classId = that.BjType_enum[d - 1].Id;
          that.getDataListFu(
            that.currentPage,
            that.courseId,
            that.scoreId,
            that.subjectId,
            that.classId,
            that.studentId,
            that.num6,
            this.searchValue,
            this.CourseIds
          );
        }
      },
      //适合学生
      StudentClick(e) {
        let that = this;
        that.num5 = e;
        that.currentPage = 1;
        if (that.num5 == 0) {
          that.studentId = 0;
          that.getDataListFu(
            that.currentPage,
            that.courseId,
            that.scoreId,
            that.subjectId,
            that.classId,
            that.studentId,
            that.num6,
            this.searchValue,
            this.CourseIds
          );
        } else {
          that.studentId = that.Student_enum[e - 1].Id;
          that.getDataListFu(
            that.currentPage,
            that.courseId,
            that.scoreId,
            that.subjectId,
            that.classId,
            that.studentId,
            that.num6,
            this.searchValue,
            this.CourseIds
          );
        }
      },
      //排序方式
      pxfsFu(f) {
        let that = this;
        that.num6 = f;
        // console.log(that.num6)
        that.currentPage = 1;
        that.getDataListFu(
          that.currentPage,
          that.courseId,
          that.scoreId,
          that.subjectId,
          that.classId,
          that.studentId,
          that.num6,
          this.searchValue,
          this.CourseIds
        );
      },
      // 搜索
      searchClick() {
        let that = this;
        that.getDataListFu(
          1,
          that.courseId,
          that.scoreId,
          that.subjectId,
          that.classId,
          that.studentId,
          that.num6,
          this.searchValue,
          this.CourseIds
        );
      },
      searchfocus(e) {
        this.enter = e;
      },
      searchblur(e) {
        this.enter = e;
      },
      searchEnter() {
        document.onkeydown = e => {
          //13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
          if (e.keyCode === 13 && this.enter == 1) {
            //回车后执行搜索方法
            this.searchClick();
          }
        };
      }
    },
    mounted: function() {
      //自动触发写入的函数
      let that = this;
      that.tokenkey = that.$cookies.get("token");
      // 列表搜索框
      this.searchValue = this.keyword;
      if (this.keyword == undefined) {
        this.searchValue = "";
      }
      // console.log('searchValue2', this.searchValue)
      // 列表初始化
      that.getDataListFu(
        1,
        that.courseId,
        that.scoreId,
        that.subjectId,
        that.classId,
        that.studentId,
        that.num6,
        this.searchValue,
        this.CourseIds
      );
      //获取枚举列表
      let enumBox = sessionStorage.getItem("enum");
      that.enumList = JSON.parse(enumBox);
      //课程类型枚举
      that.enumList.filter(item => {
        if (item.Code === "CourseType") {
          that.CourseType_enum = item.List;
        }
      });
      // console.log(that.CourseType_enum)
      //班级类型枚举
      that.enumList.filter(item => {
        if (item.Code === "ClassType") {
          that.BjType_enum = item.List;
        }
      });

      //适用学生 枚举
      that.enumList.filter(item => {
        if (item.Code === "ApplyStudent") {
          that.Student_enum = item.List;
        }
      });

      let kmNumbers = [];
      that.enumList[0].List.filter(item => {
        if (item.Type === 2) {
          kmNumbers.push(item.Name);
        }
      });
    }
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* 课程包 */
  .courseBox {
    position: absolute;
    top: 10px;
    right: 0;
    width: 72px;
    height: 30px;
    line-height: 30px;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    background: rgba(0, 0, 0, 0.3);
    font-size: 14px;
    color: #fff;
    text-align: center;
  }

  .bottombox {
    position: relative;
    z-index: 9;
  }

  .BreadcrumbNavigation {
    width: 1200px;
    text-align: left;
    font-size: 20px;
    line-height: 75px;
    margin: 0 auto 20px;
    color: #337CFF;
  }

  .BreadcrumbNavigation strong {
    color: #666666;
    font-weight: normal;
  }

  .BreadcrumbNavigation a {
    font-size: 20px;
    color: #337CFF;
  }

  .BreadcrumbNavigation span {
    font-size: 20px;
    color: #333333;
  }

  .screen {
    background: #fff;
  }

  .screen_2 {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .screen_2.up {
    display: none;
  }

  .screen_2 p {
    margin-bottom: 30px;
    text-align: left;
    display: table;
  }

  .screen_2 p strong {
    display: inline-block;
    margin-right: 24px;
    float: left;
    font-weight: 400;
    font-size: 20px;
    color: #666666;
    line-height: 28px;
  }

  .screen_2 p span {
    display: inline-block;
    width: 1070px;
    float: left;
  }

  .screen_2 p a {
    display: inline-block;
    min-width: 82px;
    height: 28px;
    font-size: 20px;
    line-height: 28px;
    border-radius: 14px 14px 14px 14px;
    margin-right: 10px;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    cursor: pointer;
    padding: 0 20px;
    box-sizing: border-box;
    transition: all 0.25s ease-in;
    -moz-transition: all 0.25s ease-in;
    -webkit-transition: all 0.25s ease-in;
  }

  .screen_2 p a:hover {
    color: rgba(51, 124, 255, 1);
  }

  .screen_2 p a.side {
    background: rgba(51, 124, 255, 0.05);
    color: rgba(51, 124, 255, 1);
  }

  .screen_3 {
    width: 1200px;
    padding-bottom: 30px;
    margin: 0 auto;
    box-sizing: border-box;
    text-align: left;
  }

  .screen_3 strong {
    display: inline-block;
    font-weight: 500;
    font-size: 26px;
    color: #666666;
    line-height: 26px;
    font-weight: 500;
    margin-right: 50px;
  }

  .screen_3 a {
    display: inline-block;
    min-width: 82px;
    font-weight: 400;
    font-size: 26px;
    color: #333333;
    line-height: 26px;
    text-align: left;
    margin-right: 50px;
  }

  .screen_3 a.side {
    color: #FF0659;
  }

  .screen_3 span {
    float: right;
    font-size: 14px;
    color: #666666;
    line-height: 36px;
  }

  .main {
    width: 100%;
    padding-bottom: 78px;
  }

  .main_list li {
    width: 285px;
    height: 295px;
    float: left;
    background: #FBFBFB;
    position: relative;
    margin-right: 20px;
    margin-bottom: 20px;
    overflow: hidden;
  }

  .main_list li:nth-child(4n) {
    margin-right: 0;
  }

  .main_list li a {
    display: block;
    width: 285px;
    height: 322px;
    overflow: hidden;
  }

  .main_list li dt {
    width: 285px;
    height: 185px;
    overflow: hidden;
  }

  .main_list li dt img {
    width: 285px;
    height: 185px;
    display: block;
  }

  .main_list li .dd1 {
    width: 265px;
    padding: 10px 10px 0;
    text-align: left;
    background: url(../../assets/index/to1.png) 261px 10px no-repeat;
    background-size: 14px 14px;
  }

  .main_list li .dd1 h2 {
    height: 20px;
    font-size: 20px;
    color: #000000;
    line-height: 20px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 10px;
  }

  .main_list li .dd1 .p1 {
    width: 100%;
    height: 22px;
    margin-bottom: 10px;
    overflow: hidden;
  }

  .main_list li .dd1 .p1 span {
    display: inline-block;
    padding: 0 10px;
    height: 22px;
    background: rgba(135, 141, 255, 0.05);
    border-radius: 13px 13px 13px 13px;
    line-height: 22px;
    text-align: center;
    font-size: 12px;
    color: #878DFF;
    margin-right: 5px;
  }

  .main_list li .dd1 .p3 {
    height: 26px;
    font-weight: 400;
    font-size: 26px;
    color: #FF0659;
    line-height: 26px;
    text-align: right;
  }

  .main_list li .dd2 {
    width: 265px;
    max-height: 200px;
    padding: 18px 10px 0;
    text-align: left;
    position: absolute;
    bottom: -300px;
    left: 0;
    background: #FBFBFB;
    transition: 0.5s ease all;
  }

  .main_list li:hover .dd2 {
    bottom: 0;
  }

  .main_list li .dd2 .p2 {
    font-weight: 350;
    font-size: 12px;
    color: #666666;
    line-height: 18px;
    margin-bottom: 8px;
  }

  .main_list li .dd2 .p1 {
    width: 100%;
    height: 22px;
    margin-bottom: 2px;
    overflow: hidden;
  }

  .main_list li .dd2 .p1 span {
    display: inline-block;
    padding: 0 10px;
    height: 22px;
    background: rgba(135, 141, 255, 0.05);
    border-radius: 13px 13px 13px 13px;
    line-height: 22px;
    background: rgba(135, 141, 255, 0.05);
    text-align: center;
    font-size: 12px;
    color: #878DFF;
    margin-right: 5px;
  }

  .main_list li .dd2 .p4 {
    font-weight: 400;
    font-size: 12px;
    color: #337CFF;
    line-height: 12px;
    text-align: right;
    padding-right: 24px;
    margin-bottom: 20px;
    background: url(../../assets/index/to2.png) right no-repeat;
    background-size: 14px 14px;
  }


  .main_list li .dd2 h2 {
    height: 20px;
    font-size: 20px;
    color: #000000;
    line-height: 20px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 10px;
  }

  .block {
    width: 1180px;
    margin: 0 auto;
    text-align: right;
  }

  .screen_S {
    width: 1180px;
    margin: 0 auto;
    padding-bottom: 40px;
    position: relative;
  }

  .screen_S input {
    width: 250px;
    height: 36px;
    background: #ffffff;
    border-radius: 21px;
    border: 1px solid #dddddd;
    padding: 0 15px;
  }

  .screen_S .search_btn {
    position: absolute;
    top: 1px;
    left: 245px;
    cursor: pointer;
    width: 36px;
    height: 36px;
    border: none;
    background: url(../../assets/personal/icon_search_Default.png) no-repeat;
    overflow: hidden;
    text-indent: -999px;
  }
</style>



// WEBPACK FOOTER //
// src/page2/courseList/course_list.vue